// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import {Tools} from '@/assets/js/common';
Vue.use(ViewUI);

Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  // console.log(to,"to");
    let token = Tools.cookie.getCookie("token");
    if(to.path == '/main/forgetpsd' && token){
        if(!Tools.cookie.getCookie("isReload")){
            Tools.cookie.addCookie("isReload", 1);
            Tools.cookie.removeCookie('token');
            window.location='/login';
            return;
        }else{
            Tools.cookie.removeCookie('isReload');
        }
    }
    if(to.path == '/main/forgetpsd' && to.query.service) {
        sessionStorage.setItem("service", to.query.service);
    }
    // debugger;
    if(to.path == '/login' &&  token) {
        let path = sessionStorage.getItem('sso_wantTo') || '/main/forgetpsd';
        next({path: path});
    }else if(!token) {
        // 重置密码，不需要登陆状态
        if(['/main/sendemail','/main/resetPsd','/main/success'].includes(to.path)) {
            next();
            return;
        }

        if(!to.query.cas) {
            if(to.path == '/') {
                sessionStorage.setItem("sso_wantTo", '/main/forgetpsd');
            } else  if(to.path !== '/login'){
                sessionStorage.setItem("sso_wantTo", to.fullPath);
            }
        }
        // 开发环境
        if(process.env.NODE_ENV == 'development') {
            if(to.query.token && to.query.expire) {
                Tools.cookie.addCookie("token", to.query.token, to.query.expire);
                Tools.cookie.addCookie("username", to.query.username, to.query.expire);
                next({path: '/login'})
            } else {
                // console.log(process.env.PROXY_TARGET,`${process.env.PROXY_TARGET}/login?frontendhost=${window.location.origin}`,"KKKKKKKKK")
                window.location=`${process.env.PROXY_TARGET}/login?frontendhost=${window.location.origin}`;
                return;
            }
        }
        // 生产环境
        if(process.env.NODE_ENV == 'production') {
            window.location='/login';
            return;
        }

      } else {
        next();
      }

})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template:'<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js